<template>
  <div class="notfound">
    <div class="notfound__mark" aria-hidden="true">✉️</div>
    <h1 class="notfound__title">Page not found</h1>
    <p class="notfound__text">
      This one didn't make it to the mailbox. The page you're looking for
      doesn't exist or may have moved.
    </p>
    <div class="notfound__actions">
      <router-link to="/" class="button primary">Back home</router-link>
      <router-link to="/create-postcard" class="button ghost">Send a postcard</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped>
.notfound {
  max-width: 520px;
  margin: 0 auto;
  padding: 72px 20px 96px;
  text-align: center;
}
.notfound__mark { font-size: 3rem; }
.notfound__title {
  color: var(--rich-black);
  font-size: 1.9rem;
  margin: 16px 0 10px;
}
.notfound__text {
  color: var(--violet-lush, #666);
  line-height: 1.5;
  margin: 0 0 28px;
}
.notfound__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}
.button {
  padding: 12px 22px;
  border-radius: 10px;
  font-weight: 600;
  text-decoration: none;
  border: none;
  cursor: pointer;
}
.button.primary { background: var(--accent2-color); color: #fff; }
.button.primary:hover { background: var(--accent-color); }
.button.ghost { background: #f2f2f2; color: var(--rich-black); }
.button.ghost:hover { background: #e8e8e8; }
</style>
